import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#E91E63',
      light: '#F48FB1',
      dark: '#C2185B',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#9C27B0',
      light: '#BA68C8',
      dark: '#7B1FA2',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 16, boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)' },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#E91E63', light: '#F48FB1', dark: '#C2185B' },
    secondary: { main: '#9C27B0', light: '#BA68C8', dark: '#7B1FA2' },
    background: { default: '#0a0a1a', paper: '#1a1a2e' },
  },
  typography: { fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif' },
  shape: { borderRadius: 12 },
});

export const sakuraColors = {
  primary: '#E91E63',
  primaryLight: '#F48FB1',
  primaryDark: '#C2185B',
  secondary: '#9C27B0',
  background: { dark: '#0a0a1a', darker: '#1a1a2e', light: '#f5f5f5' },
};

export default theme;
